/* eslint-disable max-statements */
import React from "react";
import PropTypes from "prop-types";
import DISCOUNT_ICON from "../images/car-card-icons/discount.svg";
import VIEWED_ICON from "../images/car-card-icons/viewed.svg";
import RESERVED_ICON from "../images/car-card-icons/lock.svg";
import NEW_ICON from "../images/car-card-icons/new.svg";
import DEALER_ICON from "../images/car-card-icons/dealer.svg";
import PRICE_DROP from "../images/car-card-icons/price-drop.svg";
import COMING_SOON_ICON from "../images/car-card-icons/coming-soon.svg";
import { INVENTORY_CAR_CARD_LABELS } from "../../../constants/app-constants";
const InventoryCarCardIcons = ({ label, height, width }) => {
    let icon = null;
    if (label === INVENTORY_CAR_CARD_LABELS.DISCOUNT) {
        icon = DISCOUNT_ICON;
    }
    if (label === INVENTORY_CAR_CARD_LABELS.VIEWED) {
        icon = VIEWED_ICON;
    }
    if (label === INVENTORY_CAR_CARD_LABELS.RESERVED) {
        icon = RESERVED_ICON;
    }
    if (label === INVENTORY_CAR_CARD_LABELS.NEW) {
        icon = NEW_ICON;
    }
    if (label === INVENTORY_CAR_CARD_LABELS.DEALER) {
        icon = DEALER_ICON;
    }
    if (label === INVENTORY_CAR_CARD_LABELS.PRICE_DROP) {
        icon = PRICE_DROP;
    }
    if (label === INVENTORY_CAR_CARD_LABELS.COMING_SOON) {
        icon = COMING_SOON_ICON;
    }
    return icon && <img src={icon} height={height} width={width} />;
};

InventoryCarCardIcons.propTypes = {
    label: PropTypes.any,
    height: PropTypes.any,
    width: PropTypes.any
};

export default InventoryCarCardIcons;
